export const listConstant = {
  childHeader: 'CSR CALENDAR',
  addButtonLable: 'New CSR CALENDAR',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW CSR CALENDAR',
};

export const createConstant = {
  childHeader: 'CSR CALENDAR PLAN',
  theadHeader: 'CSR CALENDAR PLAN',
  extracolSpan: 5,
};

export const checkListList = {
  childHeader: 'CSR CALENDAR PLAN STATUS',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  deleteurl: 'tniCsrPlanRoute',
  gettableDataurl: 'tniCsrPlanRoute/monthly',
  getPlanByid: 'tniCsrPlanRoute',
  createPlanByid: 'tniCsrPlanRoute',
  updatePlanByid: 'tniCsrPlanRoute',
  sync: 'tniCsrPlanRoute/handleSync',
  getAllCheckList: 'tniCsrPlanRoute/getAllCheckList',
  checkListStatus: 'tniCsrPlanRoute/handleStatus',
  checklistUpload: 'tniCsrPlanRoute/handleUpload',
  checklistDeleteImage: 'tniCsrPlanRoute/handleDeleteImage',
  checklistData: 'tniCsrPlanRoute/checklistRoute',
  categoryTopic: 'tni/getTopicByCategory',
};

export const navigationConstant = {
  createPlanSchedule: '/common/tniCsrPlanCreate',
  createChecklist: '/common/tniCsrPlanChecklistCreate',
};
